// Modules
import { Action, createReducer, on } from '@ngrx/store';

// Actions
import * as ForcedPasswordChangeActions from '@store/actions/forced-password-change.actions';

export interface ForcedPasswordChangeState {
  pending: boolean; // True when mustChangePassword was true in the login response
  challengeId: string | null; // The passwordChangeChallengeId from the login response
  changing: boolean; // Loading state during API call
  fieldError: string | null; // Server validation message to show under the password field
}

export const initialState: ForcedPasswordChangeState = {
  pending: false,
  challengeId: null,
  changing: false,
  fieldError: null,
};

const forcedPasswordChangeReducer = createReducer(
  initialState,
  // Pending: mustChangePassword: true detected — store challengeId, flag flow as pending
  on(
    ForcedPasswordChangeActions.forcedPasswordChangePending,
    (state, action) => ({
      ...state,
      pending: true,
      challengeId: action.payload.challengeId,
    })
  ),
  // Requested: form submitted — start loading, clear previous field error
  on(ForcedPasswordChangeActions.forcedPasswordChangeRequested, state => ({
    ...state,
    changing: true,
    fieldError: null,
  })),
  // Success: password changed — clear flow state
  on(ForcedPasswordChangeActions.forcedPasswordChangeSuccess, state => ({
    ...state,
    changing: false,
    pending: false,
    challengeId: null,
  })),
  // Failed: API error — stop loading, store field error (if any) for display under the input
  on(
    ForcedPasswordChangeActions.forcedPasswordChangeFailed,
    (state, action) => ({
      ...state,
      changing: false,
      fieldError: action.payload.fieldError ?? null,
    })
  ),
  // Cleared: component destroyed or flow completed — reset to initial state
  on(ForcedPasswordChangeActions.forcedPasswordChangeCleared, () => ({
    ...initialState,
  }))
);

export function reducer(
  state: ForcedPasswordChangeState | undefined,
  action: Action
): ForcedPasswordChangeState {
  return forcedPasswordChangeReducer(state, action);
}
